export default "__VITE_ASSET__a4bcfb5b__"